import { useContext } from "react";

import { BookmarkAdd, BookmarkRemoveOutlined } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

import { AssignRoles } from "../../../consts/assign-roles";
import { UserRole } from "../../../consts/user-role";
import { useAuth } from "../../../hooks/useAuth";
import { useModal } from "../../../hooks/useModal";
import { CafsTreeNodeType } from "../../../types/cafs-tree-node-type";
import { DashboardContext } from "../DashboardContext";

import { AssignCafsModal } from "./AssignCafsModal";

type CafsAssignProps = {
  node: CafsTreeNodeType;
};

export function CafsAssign({ node }: CafsAssignProps) {
  const { open, handleOpen, handleClose } = useModal();
  const { user } = useAuth();
  const { selectedDataset } = useContext(DashboardContext);

  const shouldRender =
    !node.isRoot &&
    selectedDataset != null &&
    AssignRoles.includes(user?.Role as UserRole);

  return shouldRender ? (
    <>
      <Tooltip
        title={
          node.isAssigned
            ? "Remove this CAFS from the dataset"
            : "Assign this CAFS to the dataset"
        }>
        <div>
          {node.isAssigned ? (
            <BookmarkRemoveOutlined
              className="text-primary hover:text-orange-400 text-xl cursor-pointer"
              onClick={handleOpen}
            />
          ) : (
            <BookmarkAdd
              className="text-primary hover:text-green-600 text-xl cursor-pointer"
              onClick={handleOpen}
            />
          )}
        </div>
      </Tooltip>
      <AssignCafsModal open={open} onClose={handleClose} node={node} />
    </>
  ) : null;
}
